module.exports = __webpack_public_path__ + "icon-del.png?b07a2b35f43564181a98bf69cc08a70d";


//////////////////
// WEBPACK FOOTER
// ./Content/img/icon-del.png
// module id = 17
// module chunks = 1